import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Box } from "@mui/material";

const SearchFiedComponent = (props) => {
    const { placeholder, onChange, value } = props;
    return (
        <Box
            sx={{
                position: "relative",
            }}
        >
            <input
                type="search"
                name="search"
                autoComplete="off"
                autoFocus="true"
                id="search"
                className="customeSearch"
                style={{
                    padding: "14px 18px 14px 35px",
                    borderRadius: "6px",
                    background: "#DEE6F2",
                    // background: "#fff",
                    border: "none",
                    width: "300px",
                    color: `#164FA1`,
                    outline: "none",
                    WebkitAppearance: "none",
                }}
                value={value}
                placeholder={placeholder}
                onChange={onChange}
            />
            
            <SearchIcon
                sx={{
                    left: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    height: "100%",
                    fontSize: "20px",
                    // color: "#D8D4FF",
                    color: `#164FA1`,
                    position: "absolute",
                }}
            />
            {props.children}
        </Box>
    );
};

export default SearchFiedComponent;
